module.exports = __webpack_public_path__ + "static/media/deposito.b4c633cd.svg";